export default __webpack_public_path__ + "static/media/conab_video_egg_donnor.17dbfcbc.mp4";